import { DatasetIdentifierStr } from "../dataset/DatasetIdentifierStr";

export class ProductTemplateTaskSelectionOptions {
  id?: number;

  productTemplateRef?: string;

  entryDataset: DatasetIdentifierStr | null = null;

  useDataset: boolean = false;

  latestEntryCount: number = 10;

  filterQuery?: string = undefined;
}
